import React, { useState } from "react";
import { Button, Card, Image } from "react-bootstrap";
import ModalDetailPersonne from "./ModalDetailPersonne";
import icon_colidee from "../../../assets/images/tools/icon_colidee.png";
import icon_teams from "../../../assets/images/tools/icon_teams.png";
import genericAvatar from "../../../assets/images/generic-avatar.jpeg";
import { useTranslation } from "react-i18next";
import { FaRegQuestionCircle } from "react-icons/fa";

const PersonneCard = (props) => {
  const { personne } = props;
  const { t } = useTranslation();
  const [showDetails, setShowDetails] = useState(false);

  const handleShowDetails = () => {
    setShowDetails(true);
  };

  const handleCloseDetails = () => {
    setShowDetails(false);
  };

  const retourneLettresMBTI = () => {
    let profil = "";
    let lettreSupplementaire = "";

    profil += personne.lettresMbti[0] > 50 ? "I" : "E";
    profil += personne.lettresMbti[1] > 50 ? "N" : "S";
    profil += personne.lettresMbti[2] > 50 ? "F" : "T";
    profil += personne.lettresMbti[3] > 50 ? "P" : "J";
    lettreSupplementaire = personne.lettresMbti[4] > 50 ? "T" : "A";

    return (
      <a
        href={process.env.REACT_APP_URL_EASYGOUV + "profilsMBTI/" + profil + ".pdf"}
        target="_blank"
        rel="noreferrer"
        style={{ fontSize: ".7em" }}
      >
        {profil}
        {/* {profil}-{lettreSupplementaire} */}
      </a>
    );
  };

  return (
    <>
      <ModalDetailPersonne id={personne._id} show={showDetails} handleClose={handleCloseDetails} />

      <Card
        className="d-flex flex-column justify-content-between align-items-center cardPersonne"
        onClick={handleShowDetails}
      >
        <span className="overflowInContentSmall">
          <div className="d-flex flex-column">
            {personne.marque !== null && (
              <div
                className={
                  personne.marque.pinned
                    ? "containerMarque containerMarquePinned"
                    : "containerMarque"
                }
              >
                {personne.marque ? personne.marque.nom : ""}
              </div>
            )}

            {personne.marque === null && <div className="containerMarque"> </div>}
            <Card.Img
              role="button"
              className="avatar"
              variant="top"
              src={
                personne.profilePic
                  ? process.env.REACT_APP_URL_EXPRESS + "images/avatar/small/" + personne.profilePic
                  : genericAvatar
              }
            />
          </div>
          <Card.Body className="bodyPersonne">
            <Card.Text className="identite">
              {personne.prenom}
              <span className="fw-bold"> {personne.nom}</span>
            </Card.Text>
            {personne.email && (
              <div className="d-flex justify-content-around align-items-center mt-1">
                <a
                  href={
                    process.env.REACT_APP_URL_COLIDEE +
                    "/redirectMailColideurToIdProfile?email=" +
                    personne.email
                  }
                  target="_blank"
                  rel="noreferrer"
                >
                  <Image className="icon" src={icon_colidee} />
                </a>
                {personne.lettresMbti?.length > 0 && retourneLettresMBTI()}
                {personne.marque && personne.marque.moduleTeams && (
                  <a
                    href={"https://teams.microsoft.com/l/chat/0/0?users=" + personne.email}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <Image className="icon" src={icon_teams} />
                  </a>
                )}
              </div>
            )}
          </Card.Body>
        </span>
        <Button className="buttonCard">{t("public.boutons.je_contacte")}</Button>
      </Card>
    </>
  );
};

export default PersonneCard;
